import Component from "./GenericTableEditor";
export default Component;
